export default "__VITE_ASSET__CuMSHeT0__"